import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getThemesPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`theme_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/themes/panel", queryString);
};
export const getThemeLista = async () => {
    const res = await getData('/themes');
    return res
}


export const getThemeById = async (id) => {
    const res = await getData(`/themes/${id}`)
    return res
}

export const postTheme = async (body) => {
    const res = await postData('/themes', body)
    return res
}

export const patchTheme = async (id, body) => {
    const res = await patchData(`/themes/${id}`, body)
    return res
}

export const deleteTheme = async (id) => {
    const res = await deleteData(`/themes/${id}`)
    return res
}